var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrance(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0h20v44H22V0z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C3.373 0 0 4.925 0 11v22c0 6.075 3.373 11 10 11h12V0H10z",
    fill: "#00209F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 0H42v44h12c6.627 0 10-4.925 10-11V11c0-6.075-3.373-11-10-11z",
    fill: "#EC1C24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default ForwardRef;